var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-wrapper flexDirection",style:(_vm.emptyBox)},[_c('img',{staticClass:"emptyImage",style:(_vm.emptyImageStyle),attrs:{"src":require("./empty.png"),"alt":""}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }